<script>
import AddChickenWeightRecord from '@/layer/components/AddChickenWeightRecord.vue'

export default {
  components: {
    AddChickenWeightRecord,
  },
}
</script>

<template>
  <add-chicken-weight-record />
</template>



// WEBPACK FOOTER //
// src/layer/views/AddChickenWeightRecordView.vue